export const inTheNewsEditComponent = {

    //passing title and onSubmit function for binding in main component
    template: `
            <in-the-news-main 
                page-title='Edit News'
                parent-slug='{{$ctrl.parentSlug}}' 
                details='$ctrl.details'
                disable-buttons='$ctrl.disableButtons'
                on-submit='$ctrl.onSubmit(details)'
                on-republish='$ctrl.onSubmit(details)'
                show-republish-button='$ctrl.showRepublishButton'
                show-save-publish-type-button='$ctrl.showSavePublishTypeButton'>
            </in-the-news-main>`,

    bindings: {
        details: '<',
        parentSlug: '@',
        slugUrl: '@'
    },

    //controller for InTheNewsEditComponent
    controller: class InTheNewsEditComponent {
        constructor(toastr, $state, $stateParams, AboutUsService, CompareObjectService, DynamicMenusService, SlugService) {
            'ngInject';

            this.toastr = toastr;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.aboutUsService = AboutUsService;
            this.compareObjectService = CompareObjectService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        //storing old data in savedData
        $onInit() {
            this.details = this.aboutUsService.getNewsDetailsById(this.details);
            this.showRepublishButton = this.details.publishAt === null ? false : true;
            this.showSavePublishTypeButton = !this.showRepublishButton;
            this.savedData = angular.copy(this.details);
        }

        //comparing old and new data for update on submit function
        onSubmit(details) {
            let _details = angular.copy(details);
            const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, _details, true);
            if (isUpdated) {
                let url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'edit');
                _details = this.aboutUsService._setNewsObject(_details);

                this.dynamicMenusService.updateMenuDetailsByUrl(this.slugUrl, _details)
                    .then(({ data }) => {
                        const contentDetailsUrl = this.slugService.getDetailsPageURL(url);
                        this.toastr.success('News updated successfully');
                        this._redirectToParentState(contentDetailsUrl);
                        this.disableButtons = false;
                    }).catch((err) => {
                        this.toastr.error(err);
                        this.disableButtons = false
                    });
            } else {
                this.toastr.success('Nothing to update');
                this._redirectToParentState(this.parentSlug);
                this.disableButtons = false;
            }
        }

        _redirectToParentState(slug) {
            this.$state.go('app.dashboard.DynamicMenus', {
                url: slug
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/about-us/in-the-news/in-the-news-edit/in-the-news-edit.component.js